import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import { useHistory } from 'react-router-dom';

import { fetchReportsMemberships } from '@redux/modules/reports/actions';
import Box from '@components/Box';
import { getMembershipsReports } from '@redux/modules/reports/selectors';
import Loader from '@components/Loader';
import { AsyncDispatch } from '@redux/types';
import ManagerFilterForm from '@containers/Dashboard/ManagerFilterForm';
import { fetchManagersList } from '@redux/modules/managers/actions';
import {
    getManagersList,
    getSelectedManagerId,
} from '@redux/modules/managers/selectors';
import BoxButton from '@components/BoxButton';
import { getUser } from '@redux/modules/auth/selectors';
import { UserRole } from '@t/user';

import { ReportsListTable } from './ReportListTable';
import styles from './styles.module.css';

export const ReportListMemberships: React.FC = () => {
    const dispatch = useDispatch<AsyncDispatch>();
    const history = useHistory();
    const reports = useSelector(getMembershipsReports);
    const managersList = useSelector(getManagersList);
    const selectedManagerId = useSelector(getSelectedManagerId);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const user = useSelector(getUser);
    const isSuperAdmin = user?.role === UserRole.SuperAdmin;

    useEffect(() => {
        if (!reports.length) setIsLoading(true);

        if (!managersList.length && isSuperAdmin) dispatch(fetchManagersList());
        dispatch(fetchReportsMemberships(selectedManagerId))
            .catch(() => {
                cogoToast.error('Ошибка при загрузке отчетов', {
                    position: 'top-right',
                    hideAfter: 4,
                });
            })
            .finally(() => setIsLoading(false));
    }, [dispatch, selectedManagerId]);

    const managers = managersList.map((manager) => ({
        label: manager.email,
        value: manager._id,
    }));

    const goToGoReportsBookings = useCallback(
        () => history.push('/dashboard/reports-bookings'),
        [history]
    );

    const goToGoReportsMemberships = useCallback(
        () => history.push('/dashboard/reports-memberships'),
        [history]
    );

    return (
        <div>
            {isSuperAdmin && <ManagerFilterForm managers={managers} />}
            <h1>Отчеты</h1>

            <BoxButton
                icon=""
                title="Тренировки"
                onClick={goToGoReportsBookings}
            />

            <BoxButton
                icon=""
                title="Абонементы"
                onClick={goToGoReportsMemberships}
                className={styles.actionNav}
            />

            {isLoading && <Loader />}

            {!isLoading && reports.length > 0 && (
                <Box>
                    <div className={styles.tableWrapper}>
                        <ReportsListTable reports={reports} />
                    </div>
                </Box>
            )}

            {!isLoading && !reports.length && (
                <div className={styles.noReports}>Отчетов не найдено</div>
            )}
        </div>
    );
};

export default ReportListMemberships;
